<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="resolvedViewBox"
    :width="size"
    :height="size"
    role="img"
    :aria-label="title || undefined"
    :aria-hidden="title ? 'false' : 'true'"
    :class="['ui-icon', className]
    "
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <title v-if="title">{{ title }}</title>
    <path v-for="(path, index) in icon.paths" :key="index" :d="path" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { SVG_PATHS, type SvgIconName } from './svg-paths';

const props = withDefaults(
  defineProps<{
    name: SvgIconName;
    size?: string | number;
    className?: string;
    viewBox?: string;
    title?: string;
  }>(),
  {
    size: 18,
    className: '',
    viewBox: undefined,
    title: undefined,
  },
);

const icon = computed(() => SVG_PATHS[props.name]);
const resolvedViewBox = computed(() => props.viewBox ?? icon.value?.viewBox ?? '0 0 24 24');
</script>
